
import Vue from 'vue';
export default Vue.extend({
  props: {
    headline: {
      type: Object,
      default: () => ({
        level: 'h2',
        fontStyle: 'h2',
        text: 'Neuigkeiten und Referenzen.',
      }),
    },
    copy: {
      type: String,
    },
    button: {
      type: Object,
    },
  },
  methods: {
    validateHeadline(text?: string) {
      return text && text.replace(/\n/g, ' ').trim().length > 0;
    },
  },
});
